// extracted by mini-css-extract-plugin
export default {"wrapper":"oSQ9EWUuQjbtDeGDSV1a","titleWithCurrency":"AnM9uzc7A4OLEG5dDW9w","title":"OdiPareuWAGjZ00dCGxA","currencySelect":"p3ZcV5iW3_oKOhW9MbjF"};